import React from 'react'
import {Link} from 'gatsby'
//import rawEmojis from '../../static/emojis/emojis.js'
import Work from './workExp'
import Tech from './techExpertise'
import SocialFollow from "./SocialFollow"
import * as aboutStyle from './componentStyles/about-Me.module.scss'
const AboutMe = () => {
    return (
            <div className={aboutStyle.content}>
            <h2 style={{textDecoration:"underline", fontWeight:"bold", textDecorationStyle:'double' }}>Mohammad ABS Jabed</h2>
            <p style={{marginTop:-20}}>{`{ `}<span style={{fontWeight:'bold'}}>A</span>bu<span style={{fontWeight:'bold'}}> B</span>akar <span style={{fontWeight:'bold'}}>S</span>iddqe{` }`}</p>
            <p className={aboutStyle.myParagraph}>I love to write code for myself and software systems. I am passionately curious and fascinated by distributed systems. I relish learning new things, solving problems, reading, and pushing myself outside my comfort zone.</p>
            <div style={{marginTop:-35}}>
                <SocialFollow/>
            </div>
            <div style={{marginTop: 25}} id={"#tech"}>
                <Tech/>
            </div>
            <div style={{marginTop: 15}} id={"#projects"}>
                <h3 style={{textDecoration:"underline", textDecorationStyle:"double", fontWeight:"bold" }}>
                    <p style={{marginTop:15, alignSelf:'center'}}>
                        <Link to="/projects">Projects</Link>
                    </p>
                </h3>
                
            </div>
            <div style={{marginTop: 10}} id={"#work"}>
                <Work/>
            </div>
            </div>
    )
}

export default AboutMe
